import { RouteConfig } from 'vue-router';

const XinzangwuyouList = () => import('./views/xinzangwuyou-list.vue');


const routers: RouteConfig[] = [
    {
        path: 'xinzangwuyou-list',
        component: XinzangwuyouList,
    },
    {
        path: '',
        redirect: 'xinzangwuyou-list'
    },

]
export default routers;
